export const DEFAULT_PROFILE: DogsTrust.Profile = {
	userId: "offline",
	amount: 2,
	favourites: [],
	basket: [],
	interested: [],
	adoptionSubmissions: [],
	type: "offline",
	idp: "email",
};

export const UNINITIALISED_PROFILE: DogsTrust.Profile = {
	basket: [],
	favourites: [],
	interested: [],
	adoptionSubmissions: [],
	amount: 2,
	type: "offline",
	idp: "local",
	userId: "uninitialised",
	localSyncTime: 0,
	shouldSync: false,
};
